<template lang="html">
  <div class="log-contianer">
    <HomeHeaderIndex></HomeHeaderIndex>
    <!-- <div class="bg">
      <div class="text-group">
        <p class="text-one">更新日志</p>
        <p class="text-two">Update Log</p>
      </div>
      <img :src="$store.state.static_img_url+'pic/index/logbg.png'" >
    </div> -->
    <div class="bg">
      <div>
        <p class="p1">更新日志</p>
        <p class="p2">Update Log</p>
      </div>
      <img :src="$store.state.static_img_url + 'pic/index/logbg.png'">
    </div>
    <div class="axis-area">
      <div class="left">
        <div class="year-item" :class="{'active': index == active_index}" v-for="item,index in list" :key="index" @click="active_index = index">{{item.name}}</div>
      </div>
      <div class="right">
        <div class="axis"></div>
        <div class="list">
          <div class="item" v-for="item,index in list[active_index].child" :key="index">
            <div class="mask">
              <div class="circle big" v-if="index==0 && active_index==0">
                <img :src="$store.state.static_img_url+'pic/index/c4.png'">
                <div class="content">new</div>
              </div>
              <div class="circle small" v-else>
                <img :src="$store.state.static_img_url+'pic/index/c4s.png'">
                <div class="content"></div>
              </div>
              <div class="line-group" :class="{'big': index==0 && active_index==0}">
                <div class="line-side"></div>
                <div class="line-center"></div>
                <div class="line-side"></div>
              </div>
            </div>
            <div class="data">
              <div class="version-time" @click="openOrClose(item.id)">
                <p class="version">{{item.version}}</p>
                <p class="time">{{dealTime(item.publish_time)}} <i class="iconfont" v-html="isOpen(item.id)?'&#xe73c;':'&#xe73d;'"></i> </p>
              </div>
              <div class="desc" v-html="item.content" v-if="isOpen(item.id)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getVersion } from '../../service'
import HomeHeaderIndex from '@/components/HomeHeaderIndex.vue'
import moment from 'moment'
export default {
  data() {
    return {
      list: [
        {
          child:[]
        }
      ],
      active_index: 0,
      opened:[]
    }
  },
  components: {
    HomeHeaderIndex
  },
  methods: {
    async getVersion() {
      let res = await getVersion({
        user_key: this.$store.state.user_key,
        type: '8'
      }, (error)=> { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.list = res.res
        let temp = []
        for(let item of res.res) {
          let this_year = moment(item.publish_time).format("YYYY")
          if (temp.find(i => i.name == this_year)) {
            temp.find(i => i.name == this_year).child.push(item)
          } else {
            temp.push({
              name: this_year,
              child: [item]
            })
          }
        }
        this.list = temp
        this.active_index = 0
        this.opened.push(temp[0].child[0].id)
      } else {
        this.$Message.error(res.message)
      }
    },
    dealTime(publish_time) {
      return moment(publish_time).format("YYYY年MM月DD日")
    },
    isOpen(id) {
      return this.opened.indexOf(id) != -1
    },
    openOrClose(id) {
      let index = this.opened.indexOf(id)
      if (index == -1) {
        this.opened.push(id)
      } else {
        this.opened.splice(index, 1)
      }
    }
  },
  created() {
    this.getVersion()
  }
}
</script>

<style lang="stylus" scoped>
.log-contianer
  .bg
    position: relative
    height 400px
    display flex
    justify-content center
    overflow hidden
    position relative
    // .text-group
    //   width: 1200px
    //   position: absolute
    //   top: 35%
    //   left: 50%
    //   transform: translateX(-50%)
    //   .text-one
    //     color: #FFFFFF
    //     font-size: 40px
    //     text-align: center
    //   .text-two
    //     font-size: 22px
    //     color: #fff
    //     margin-top: 10px
    //     text-align: center
    // img
    //   width: 100%
    img
      display block
      height 400px
    div
      position absolute
      left 50%
      transform translateX(-50%)
      top 150px
      text-align center
      .p1
        font-size 40px
        font-weight 400
        line-height 56px
        color rgba(255, 255, 255, 1)
      .p2
        font-size 20px
        font-weight 400
        color rgba(255, 255, 255, 1)
        line-height 28px
        padding-left 2px
  .axis-area
    width: 1200px
    margin: 0 auto
    position: relative
    top: -40px
    padding: 80px 166px 50px
    background: #fff
    display: flex
    box-shadow:0px 4px 30px 0px rgba(109,93,79,0.1)
    .left
      .year-item
        width: 148px
        height: 44px
        font-size: 14px
        color: #999999
        line-height: 44px
        cursor: pointer
        text-align: center
        &.active
          border: 1px solid #FA7A50
          background: #FFFAF5
          color: #FA7A50
        &:hover
          color: #FA7A50
    .right
      flex: 1
      margin-left: 40px
      position: relative
      height: fit-content
      .axis
        width: 30px
        height: 100%
        background:linear-gradient(180deg,#E26913,#FA7A50)
        // background: #D7EEFF
        position: absolute
        top: 0
        left: 0
        z-index: 1
      .list
        width: 100%
        position: relative
        z-index: 2
        .item
          display: flex
          align-items: stretch
          .mask
            width: 30px
            .circle
              width: 100%
              position: relative
              &.big
                height: 30px
                .content
                  width: 100%
                  line-height: 30px
              &.small
                height: 18px
                .content
                  width: 30%
                  line-height: 18px
              .content
                height: 100%
                position: absolute
                top: 0
                left: 50%
                transform: translateX(-50%)
                text-align: center
                color: #fff
                font-size: 12px
            .line-group
              display: flex
              height: calc(100% - 18px)
              &.big
                height: calc(100% - 30px)
              .line-side
                width: 18px
                background: #fff
              .line-center
                width: 4px
          .data
            margin-left: 30px
            padding-bottom: 60px
            flex: 1
            .version-time
              display: flex
              border-bottom: 1px dashed #EEEEEE
              padding-bottom: 10px
              color: #666666
              font-size: 18px
              justify-content: space-between
              cursor: pointer
              i
                margin-left: 10px
                color: #FA7A50
                vertical-align: middle
            .desc
              margin-top: 20px
              background: #FFFAF5
              padding: 20px
              line-height:26px
              font-size: 14px
              color: #333
        .item:nth-last-child(1)
          .data
            padding-bottom: 0
          .line-group
            background: #fff
</style>
